/**
 * Marca um elemento da tela como o recurso `key` do registro (`SPOTLIGHT_TARGETS`), para o ponteiro
 * de uma novidade apontar para ele. Espalhe no elemento:
 *
 *   <button {...spotlightTargetProps("inbox.new-message")}>
 *
 * Uma mesma funcionalidade que a tela desenha de formas diferentes (layout completo e simplificado,
 * cópia larga e estreita de um botão, painel aberto ou recolhido) leva a MESMA chave em cada uma,
 * com um segundo argumento que diz qual é, e o ponteiro aponta a que estiver visível:
 *
 *   <button {...spotlightTargetProps("inbox.new-message", "simple")}>
 *
 * O teste de integridade lê estas chamadas no código e confere com o registro: chave que não existe
 * lá, ou o mesmo par (chave, variante) em dois lugares, falha.
 *
 * O componente que recebe o espalhamento precisa repassar `data-*` ao elemento do DOM; um
 * componente que descarta props deixaria a marca no vazio, sem erro.
 *
 * @param {string} key chave de `SPOTLIGHT_TARGETS`
 * @param {string} [_variant] só documenta qual desenho é: não vai para o DOM
 * @returns {{ "data-spotlight-target": string }}
 */
export function spotlightTargetProps(key, _variant) {
  return { "data-spotlight-target": key };
}
